import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';


export type BannerVariant = 'success' | 'error' | 'warning';

export type Banner = {
    id: string;
    message: string;
    variant: BannerVariant;
};

export type BannerState = {
    banners: Banner[];
};

const initialState: BannerState = {
    banners: [],
};

const bannerSlice = createSlice({
    name: 'banner',
    initialState,
    reducers: {
        addBanner: (state, action: PayloadAction<Banner>) => {
            state.banners.push(action.payload);
        },
        removeBanner: (state, action: PayloadAction<string>) => {
            state.banners = state.banners.filter(b => b.id !== action.payload);
        },
    },
});

export const { addBanner, removeBanner } = bannerSlice.actions;


export const addBannerWithTimeout = createAsyncThunk<void, { message: string; variant?: BannerVariant }>(
    'banner/addBannerWithTimeout',
    async ({ message, variant = 'warning' }, { dispatch }) => {
        const id = uuidv4();
        dispatch(addBanner({ id, message, variant }));

        setTimeout(() => {
            dispatch(removeBanner(id));
        }, 5000);
    }
);


export default bannerSlice.reducer;